import { render, staticRenderFns } from "./businessChannelSelect.vue?vue&type=template&id=b2854b3c&scoped=true&"
import script from "./businessChannelSelect.vue?vue&type=script&lang=js&"
export * from "./businessChannelSelect.vue?vue&type=script&lang=js&"
import style0 from "./businessChannelSelect.vue?vue&type=style&index=0&id=b2854b3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2854b3c",
  null
  
)

export default component.exports